export type ExperienceRating = 'pouting' | 'frown' | 'meh' | 'smile' | 'grin'

export enum ExperienceRatingWeights {
  'pouting' = 1,
  'frown' = 2,
  'meh' = 3,
  'smile' = 4,
  'grin' = 5,
}
